import React from 'react';

function SidebarMenu({ menuOpen, setMenuOpen, setPage, user }) {

  if (!menuOpen) {
    return null;
  }

  console.log('SidebarMenu user:', user);

  const menuButton = (label, pageName, indent = false) => (
    <button
      onClick={() => {
        setMenuOpen(false);
        setPage(pageName);
      }}
      style={{
        display: 'block',
        width: '100%',
        textAlign: 'left',
        padding: indent ? '8px 8px 8px 24px' : '8px',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: '#1d2934',
        fontSize: indent ? '14px' : '16px',
        marginBottom: '4px'
      }}
    >
      {label}
    </button>
  );

  const menuButtonWithBadge = (label, pageName, badge, badgeColor) => (
    <button
      onClick={() => {
        setMenuOpen(false);
        setPage(pageName);
      }}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        textAlign: 'left',
        padding: '8px 8px 8px 24px',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: '#1d2934',
        fontSize: '14px',
        marginBottom: '4px'
      }}
    >
      <span>{label}</span>
      <span style={{
        fontSize: '10px',
        fontWeight: '600',
        padding: '2px 6px',
        borderRadius: '4px',
        background: badgeColor === 'pro' ? '#eff6ff' : '#f3e8ff',
        color: badgeColor === 'pro' ? '#0369a1' : '#7c3aed'
      }}>
        {badge}
      </span>
    </button>
  );

  const sectionHeader = (title) => (
    <h3 style={{
      fontSize: '12px',
      fontWeight: '600',
      color: '#5e778a',
      marginTop: '20px',
      marginBottom: '8px',
      textTransform: 'uppercase',
      letterSpacing: '0.5px'
    }}>
      {title}
    </h3>
  );

  return (
    <div
      style={{
        position: 'fixed',
        left: 0,
        top: 0,
        height: '100%',
        width: '320px',
        background: 'white',
        boxShadow: '2px 0 8px rgba(0,0,0,0.1)',
        padding: '16px',
        zIndex: 999,
        overflowY: 'auto'
      }}
    >
      <button
        onClick={() => setMenuOpen(false)}
        style={{
          position: 'absolute',
          right: '8px',
          top: '8px',
          background: 'none',
          border: 'none',
          fontSize: '24px',
          cursor: 'pointer',
          color: '#1d2934'
        }}
      >
        ×
      </button>
      <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: '#1d2934', marginBottom: '16px' }}>Menu</h2>

      {menuButton('Pricing', 'pricing')}
      {menuButton('Q&A', 'faq')}

      {user && (
        <>
          <button
            onClick={() => {
              setMenuOpen(false);
              setPage('dashboard');
            }}
            style={{
              display: 'block',
              width: '100%',
              textAlign: 'left',
              padding: '10px 8px',
              background: '#f0f9ff',
              border: '1px solid #53dafc',
              borderRadius: '4px',
              cursor: 'pointer',
              color: '#1d2934',
              marginTop: '16px',
              marginBottom: '8px',
              fontSize: '16px',
              fontWeight: '600'
            }}
          >
            Dashboard
          </button>

          {sectionHeader('Collaboration')}
          {(user.tier === 'premium' || user.tier === 'pro') && menuButtonWithBadge('Workspaces', 'workspaces', user.tier === 'pro' ? 'PRO' : 'PREMIUM', user.tier === 'pro' ? 'pro' : 'premium')}

          {sectionHeader('My Library')}
          {menuButton('Saved Patents', 'saved-patents', true)}
          {menuButton('Saved Comparisons', 'saved-comparisons', true)}
          {menuButton('Saved Searches', 'saved-searches', true)}
          {user.tier === 'pro' && menuButtonWithBadge('Comparison Workspace', 'saved-workspace-comparisons', 'PRO', 'pro')}

          {sectionHeader('My Reports')}
          {menuButton('Invention Assessments', 'saved-invention-assessments', true)}
          {menuButton('Understand a Patent', 'saved-reports-patent-decoder', true)}
          {menuButton('Patentability Check', 'saved-reports-patentability-check', true)}
          {menuButton('FTO Assessment', 'saved-reports-fto-assessment', true)}
          {menuButton('Tech Landscape', 'saved-reports-tech-landscape', true)}
          {menuButton('Prior Art Deep Dive', 'saved-reports-prior-art-deep-dive', true)}
          {menuButton('Competitive Intel', 'saved-reports-competitive-intelligence', true)}
          {user.tier === 'pro' && menuButtonWithBadge('Prior Art Pro', 'saved-reports-prior-art-pro', 'PRO', 'pro')}
          {user.tier === 'pro' && menuButtonWithBadge('FTO Pro', 'saved-reports-fto-pro', 'PRO', 'pro')}

          {sectionHeader('Tools')}
          {menuButton('Search Applications', 'search-applications', true)}
          {menuButton('Company Intel', 'company-intel', true)}
          {user.tier === 'premium' && menuButtonWithBadge('Citations', 'citations', 'PREMIUM', 'premium')}
          {user.tier === 'premium' && menuButtonWithBadge('Network', 'network', 'PREMIUM', 'premium')}
          {user.tier === 'pro' && menuButton('Citations', 'citations', true)}
          {user.tier === 'pro' && menuButton('Network', 'network', true)}
        </>
      )}
    </div>
  );
}

export default SidebarMenu;